"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwIfNotDefined = void 0;
function throwIfNotDefined(property, propertyName) {
    if (property === undefined || property === null) {
        throw new Error("Property \"" + propertyName + "\" value is not defined");
    }
}
exports.throwIfNotDefined = throwIfNotDefined;
